<script lang="ts" setup>
import { type Project, WpProject } from "@/stores/api";

const props = defineProps<{ project: Project | WpProject; size: "lg" | "sm" }>();

const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};

let title = "";
//@ts-ignore
if (props.project.title) {
    //@ts-ignore
    title = props.project.title.rendered;
    //@ts-ignore
} else if (props.project.post_title) {
    //@ts-ignore
    title = props.project.post_title;
}
</script>

<template>
    <a v-if="project" :href="project.relative_link" class="relative block cta-project-readmore" :class="`h-card-md lg:h-card-${size}`" :data-project-readmore="title">
        <div v-if="project.category && project.category.length && project.category[0].cat_name === 'sold'" class="banner bg-brown-200 text-white absolute flex z-10 bottom-auto top-0 left-0 w-full h-[56px] items-center justify-center uppercase font-bold">
            UITVERKOCHT
        </div>
        <div v-else-if="project.acf.special_note && project.acf.special_note.text" class="bg-beige-200 text-brown-200 banner absolute flex z-10 bottom-auto top-0 left-0 w-full h-[56px] items-center justify-center uppercase font-bold">
            {{ project.acf.special_note.text }}
        </div>
        <img class="lazyload w-full !h-full object-cover pt-[56px]" :data-src="project.acf.primary_image" />
        <div class="absolute bg-brown-200 w-full !h-full top-0 left-0 bg-opacity-40 bg-blend-multiply flex flex-col items-center justify-center gap-[26px]">
            <div class="text-white laud-underline lg mb-[16px]" v-html="project.acf.title"></div>
            <button class="bg-none border border-white text-white font-bold tracking-[0.1] py-[15px] px-[42px] inline-block hover:bg-none hover:text-brown-100 hover:bg-white transition-colors">kijk eens binnen</button>
        </div>
    </a>
</template>
